"use client";

import { sectionSchema } from "../../../lib/types/schema/home/sectionSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keySection } from "./keySection";

export type UseRequestSectionProps = UseRequestQueryProps & {
  id: string;
};

export const useRequestSection = ({
  id,
  ...props
}: UseRequestSectionProps) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: sectionSchema,
      urlBackendPath: `/sections/${id}`,
    },
    queryKey: keySection({ id }),
  }),
});
